import StepMeta from './StepMeta';

export default class StepperMeta {
  public stepper: StepMeta[];

  constructor(loginStepClass: string, installStepClass: string) {
    this.stepper = new Array<StepMeta>();
    this.stepper.push(new StepMeta('stepLogin', loginStepClass, 'link_account'));
    this.stepper.push(new StepMeta('stepInstall', installStepClass, 'link_dealer_page'));
  }
}
